
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
interface listDataVM {
    title: string;
    isShow: string;
    disabled: boolean;
}
@Component({
    components: {},
})
export default class ListFilterPanelAdmin extends Vue {
    @Prop({})
    public list: listDataVM[];

    @Prop()
    public disable: Boolean;
}
